// adapters/CesiumAdapter.ts
import * as Cesium from "cesium";
import type { MapAdapter } from "../core/MapAdapter";
import "cesium/Build/Cesium/Widgets/widgets.css";
import type { MapViewState } from "../types/MapTypes";
import type { MapLayer } from "../layers/types";

export class CesiumAdapter implements MapAdapter {
  private viewer?: Cesium.Viewer;

  async init(container: HTMLDivElement) {
    Cesium.Ion.defaultAccessToken = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhMDUyYzNjZC1jNmRhLTQ4NjgtODZhMC1lMTA5NWE3ODYxNjEiLCJpZCI6NDk5OTksImlhdCI6MTY1MTYzMzk0N30.XObuMJ9H-NZi8UX4G5uq2qZsM6S_vmUorNg6kbuxWcw`;
    const creditDiv = document.createElement("div");
    creditDiv.style.display = "none";
    container.appendChild(creditDiv);
    this.viewer = new Cesium.Viewer(container, {
      animation: false,
      baseLayerPicker: false,
      fullscreenButton: false,
      geocoder: false,
      homeButton: false,
      infoBox: false,
      navigationHelpButton: false,
      sceneModePicker: false,
      selectionIndicator: false,
      timeline: false,
      creditContainer: creditDiv,
      terrainProvider: await Cesium.createWorldTerrainAsync().catch(() => undefined),
    });
  }

  setView(view: MapViewState) {
    this.viewer?.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(view.center[0], view.center[1], 1000000),
    });
  }

  setCenter(lng: number, lat: number) {
    this.viewer?.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(lng, lat, 1000000),
    });
  }

  setBasemap(cfg: MapLayer | undefined) {}

  getView(): MapViewState {
    return {
      center: [0, 0],
      zoom: 0,
    };
  }

  getMapInstance(): Cesium.Viewer | undefined {
    return this.viewer;
  }

  destroy() {
    this.viewer?.destroy();
  }

  resize() {}

  syncLayers(mapLayers: MapLayer[]): void {}
}
